export default __webpack_public_path__ + "static/media/bulbs.016e8ca8.png";